export const hotelInformation = [
  'Country',
  'Place',
  'Check-in Date',
  'Check-out Date',
  'Preferred Hotel',
  'Traveller',
];
